import React from "react";

const Welcome = () => {
  return (
    <section
      id="our-practice"
      className="relative bg-[#FBF8F1] py-10 overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, #B79A68 0%, transparent 50%), radial-gradient(circle at 80% 80%, #B79A68 0%, transparent 50%)",
        }}
      />
      <div className="relative max-w-5xl mx-auto px-6 text-center">
        <p className="font-script text-4xl md:text-5xl gold-gradient-text mb-2">
          Welcome To
        </p>
        <h2 className="font-cinzel text-2xl md:text-4xl gold-gradient-text tracking-[0.15em]">
          GALLERIA DENTAL OF MANALAPAN
        </h2>
        <div className="flex items-center justify-center gap-3 my-7">
          <span className="h-px w-16 bg-gradient-to-r from-transparent to-[#B79A68]" />
          <span className="text-[#7D6A42] text-xs uppercase tracking-[0.4em]">
            Boutique Dentistry
          </span>
          <span className="h-px w-16 bg-gradient-to-l from-transparent to-[#B79A68]" />
        </div>
        <p className="text-[#4E5750]/90 leading-relaxed max-w-3xl mx-auto text-base md:text-lg mb-4">
          We see our exclusive dental practice as an extension of your home — a
          place where you always feel welcome and comfortable.
        </p>
        <p className="text-[#4E5750]/80 leading-relaxed max-w-3xl mx-auto">
          It&apos;s a place where you can come to relax, heal, rejuvenate, and
          walk out with a healthy and beautiful smile feeling great about
          yourself and life in general. Our boutique practice blends advanced
          dental medicine with the calming amenities of a luxury spa.
        </p>
      </div>
    </section>
  );
};

export default Welcome;
